import { FC } from 'react';
import { styled } from '@mui/material';
import classNames from 'classnames';

import { Icon, IconProps } from './Icon';

export type DragHandleIconProps = Omit<IconProps, 'name'> & {
  disabled?: boolean;
};

const StyledIcon = styled(Icon)`
  &:not(.disabled) {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    &:active,
    &:hover {
      color: ${({ theme }) => theme.palette.action.active};
    }
  }

  &.disabled {
    opacity: 0;
  }
`;

export const DragHandleIcon: FC<DragHandleIconProps> = ({
  className,
  color = 'disabled',
  disabled,
  fontSize = 'small',
  ...rest
}) => (
  <StyledIcon
    className={classNames(className, { disabled })}
    color={color}
    fontSize={fontSize}
    name='dragIndicator'
    {...rest}
  />
);
